import type { CartUI } from '@libs/common-node';
import { DeliveryType } from '@libs/core';

export function getCartLineItemsSignature(cart: CartUI | null | undefined): string | null {
    if (!cart?.fulfillmentGroups?.length) return null;
    const pairs = cart.fulfillmentGroups.flatMap(group => {
        const methodKey = (group.fulfillmentMethod ?? '').toLowerCase();
        return (group.items ?? []).map(item => {
            const isAutoshipLine =
                methodKey === DeliveryType.AUTOSHIP.toLowerCase() ||
                Boolean(item.autoshipFrequency && item.autoshipFrequencyUnitOfMeasure);
            const purchaseKey = isAutoshipLine
                ? `as:${item.autoshipFrequency ?? ''}:${item.autoshipFrequencyUnitOfMeasure ?? ''}`
                : 'ot';
            return `${methodKey}:${item.sku}:${item.quantity}:${purchaseKey}`;
        });
    });
    if (pairs.length === 0) return null;
    return [...pairs].sort((a, b) => a.localeCompare(b)).join(',');
}
